/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function ($, Drupal, window, document) {
  'use strict';
  Drupal.behaviors.woarnsinn = {
    attach: function (context, settings) {


      /************************************************************/
      /*												REPONSIVE TABLES									*/
      /************************************************************/
      $(once('wrap-table', 'table:not(.no-responsive)', context)).each(function () {
        const $table = $(this);

        // Schon verpackt? raus.
        if ($table.parent('.table-scroll').length) return;

        // Optional: Tabelle etwas “breiter machen”, damit horizontales Scrollen Sinn ergibt
        $table.addClass('min-w-max'); // Tailwind: min-width: max-content

        // Wrapper erstellen (Tailwind-Klassen für hübsches Scrolling)
        const $wrapper = $(
          '<div class="table-scroll overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0" role="region" aria-label="Scrollbare Tabelle" tabindex="0"></div>'
        );

        // Verpacken
        $table.wrap($wrapper);
      });
    }
  };
})(jQuery, Drupal, window, document);
